import pluralize from 'pluralize';
import { memo, useMemo } from 'react';

import { BoardIcon } from '@air/design-icons';

export type BoardMetaDataProps = {
  itemCount?: number;
};

export const BoardMetaData = memo(({ itemCount }: BoardMetaDataProps) => {
  const itemCountPhrase = useMemo(() => {
    // itemCount will be undefined when a new board is created in Table View
    const count = itemCount ?? 0;

    return <> &middot; {pluralize('item', count, true)}</>;
  }, [itemCount]);

  return (
    <div className="pointer-events-none -ml-1 flex items-center gap-1">
      <div
        className="pointer-events-none flex h-5 min-w-0 items-center gap-1 rounded-4 px-1 font-semibold text-12 text-gray-11 hover:bg-gray-3"
        data-disableselect="true"
      >
        <BoardIcon className="shrink-0" size="xs" />
        <span className="truncate">Board{itemCountPhrase}</span>
      </div>
    </div>
  );
});

BoardMetaData.displayName = 'BoardMetaData';
